// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__14-ft","spin":"styles_spin__1c8CQ"};